import React from 'react';
import { COMPANY_NAME, SUPPORT_EMAIL, PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from '../siteConfig';

// A policy link that opens in a new tab, or plain text if the policy URL isn't set yet.
export function PolicyLink({ url, children, style }) {
  if (!url) return <>{children}</>;
  return <a href={url} target="_blank" rel="noopener noreferrer" style={style}>{children}</a>;
}

// Shown at the bottom of every page (added once in App.js); hidden when printing a filing.
function SiteFooter() {
  return (
    <footer style={styles.footer} className="no-print">
      <p style={styles.line}>
        <strong>Need help with this website?</strong>{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} style={styles.link}>{SUPPORT_EMAIL}</a>
      </p>
      <p style={{ ...styles.line, fontStyle: 'italic' }}>
        Questions about a filing? Contact your town's assessor's office.
      </p>
      <p style={styles.small}>
        © {new Date().getFullYear()} {COMPANY_NAME} · MAtownforms is a service of {COMPANY_NAME}
        {/* policy links only appear once their URLs are set in siteConfig.js */}
        {PRIVACY_POLICY_URL && <> · <PolicyLink url={PRIVACY_POLICY_URL} style={styles.link}>Privacy Policy</PolicyLink></>}
        {TERMS_OF_SERVICE_URL && <> · <PolicyLink url={TERMS_OF_SERVICE_URL} style={styles.link}>Terms of Service</PolicyLink></>}
      </p>
    </footer>
  );
}

const styles = {
  footer: {
    backgroundColor: '#f4f6f9',
    borderTop: '1px solid #dde3ea',
    padding: '24px 16px',
    textAlign: 'center',
    color: '#555',
  },
  line: {
    fontSize: '14px',
    margin: '0 0 6px',
  },
  small: {
    fontSize: '12px',
    color: '#777',
    margin: '12px 0 0',
  },
  link: {
    color: '#1a3a5c',
  },
};

export default SiteFooter;
